import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export function ProtectedRoute({ permission = [] }) {
  const { hasPrivilege } = useAuth();
  const location = useLocation();
  const hasPermission = Array.isArray(permission)
    ? permission.some((requiredPermission) => hasPrivilege(requiredPermission))
    : hasPrivilege(permission);

  if (!hasPermission) {
    return (
      <Navigate
        to="/access-denied"
        replace
        state={{
          accessDenied: true,
          from: location.pathname,
        }}
      />
    );
  }
  return <Outlet />;
}
export default ProtectedRoute;
